import { Player } from "@lottiefiles/react-lottie-player";
import HistoryIcon from "../lottie/HistoryIcon";

const NoHistory = () => {
  return (
    <div className="flex items-center justify-center pt-7">
      <div>
        <Player autoplay loop className="h-40 w-60" src={HistoryIcon} />
        <h3 className="dark:text-darkGray max-w-80 text-center text-sm text-gray-600">
          Looks like there's no recent activity to show here. Get started by
          making a transactions
        </h3>
      </div>
    </div>
  );
};

export default NoHistory;
